{
  "login": "Iniciar sesión",
  "logout": "Cerrar sesión",
  "email": "Correo electrónico",
  "emailAddress": "Correo electrónico",
  "emailPlaceholder": "nombre@empresa.com",
  "password": "Contraseña",
  "forgotPassword": "¿Olvidaste tu contraseña?",
  "rememberMe": "Recordarme",
  "signIn": "Iniciar sesión",
  "signUp": "Registrarse",
  "user": "Usuario",
  "tagline": "Plataforma de Gestión de Arriendoes",
  "welcomeBackSubtitle": "Bienvenido de nuevo. Por favor ingresa tus datos.",
  "createAccountSubtitle": "Crea una cuenta para comenzar a gestionar tus propiedades.",
  "showPassword": "Mostrar contraseña",
  "hidePassword": "Ocultar contraseña",
  "quickAccess": "Acceso Rápido (QA)",
  "quickUsers": {
    "platform_sovereign": "Admin Soberano de Plataforma ({{name}})",
    "platform_admin": "Admin de Plataforma ({{name}})",
    "admin": "Administrador ({{name}})",
    "manager": "Gerente ({{name}})",
    "owner": "Propietario ({{name}})",
    "tenant": "Arrendatario ({{name}})",
    "vendor": "Proveedor ({{name}})",
    "multi": "Multi-Rol Adaptativo ({{name}})"
  },
  "enterEmail": "Introduce una dirección de correo",
  "loginFailed": "Error al iniciar sesión",
  "authFailed": "Error de autenticación",
  "apiError": "{{message}}",
  "guestSessionDetected": "Sesión de invitado activa",
  "guestSessionDescription": "Tienes un borrador de invitado sin guardar. Al iniciar sesión se vinculará automáticamente a tu cuenta.",
  "guestSessionMigrated": "Tu borrador de invitado se guardó en tu cuenta con éxito.",
  "passwordMode": "Contraseña",
  "magicLinkMode": "Enlace Mágico",
  "sendMagicLink": "Enviar Enlace Mágico",
  "magicLinkSentTitle": "Revisa tu correo",
  "magicLinkSentDescription": "Hemos enviado un enlace de inicio de sesión a {{email}}. Haz clic en el enlace para ingresar.",
  "signInWithPassword": "Iniciar sesión con Contraseña",
  "signInWithMagicLink": "Iniciar sesión con Magic Link",
  "or": "o",
  "resetPasswordTitle": "Restablece tu contraseña",
  "resetPasswordDescription": "Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
  "sendResetLink": "Enviar enlace de restablecimiento",
  "checkYourEmail": "Revisa tu correo",
  "resetEmailSentNotice": "Si existe una cuenta asociada a {{email}}, se ha enviado un enlace de restablecimiento.",
  "backToSignIn": "Volver a iniciar sesión",
  "setNewPasswordTitle": "Crear nueva contraseña",
  "setNewPasswordDescription": "Tu nueva contraseña debe tener al menos 8 caracteres y contener mayúsculas y números.",
  "newPassword": "Nueva contraseña",
  "confirmNewPassword": "Confirmar nueva contraseña",
  "saveNewPassword": "Restablecer contraseña",
  "ruleMinLength": "Al menos 8 caracteres",
  "ruleUppercase": "Al menos una letra mayúscula",
  "ruleNumber": "Al menos un número",
  "ruleMatch": "Las contraseñas coinciden",
  "passwordResetSuccessTitle": "Contraseña restablecida con éxito",
  "redirectingToLogin": "Redirigiendo al inicio de sesión...",
  "invalidResetLinkTitle": "Enlace inválido o expirado",
  "invalidResetLinkDescription": "Este enlace de restablecimiento no es válido o ha expirado.",
  "requestNewResetLink": "Solicitar un nuevo enlace",
  "authenticatingLink": "Iniciando sesión...",
  "pleaseWait": "Por favor espera mientras verificamos tu enlace mágico.",
  "magicLinkErrorTitle": "No se pudo iniciar sesión",
  "requestNewLink": "Solicitar un nuevo enlace",
  "tabs": {
    "signIn": "Iniciar Sesión",
    "signUp": "Crear Cuenta"
  },
  "fields": {
    "fullName": "Nombre Completo",
    "fullNamePlaceholder": "María Pérez",
    "confirmPassword": "Confirmar Contraseña",
    "phone": "Número de Teléfono",
    "phonePlaceholder": "+56 9 1234 5678"
  },
  "buttons": {
    "createAccount": "Crear Cuenta",
    "creatingAccount": "Creando Cuenta..."
  },
  "errors": {
    "passwordMismatch": "Las contraseñas no coinciden",
    "accountExists": "Ya existe una cuenta con este correo. Por favor inicia sesión."
  },
  "accountLinkedNotice": "Cuenta vinculada exitosamente con {{provider}}.",
  "enterFullName": "Por favor introduce tu nombre completo (mínimo 2 caracteres)",
  "enterValidEmail": "Por favor introduce un correo electrónico válido",
  "passwordRequirementsNotMet": "La contraseña no cumple con los requisitos de seguridad",
  "organizationName": "Nombre de la Organización",
  "organizationDefaultPlaceholder": "Por defecto tu nombre",
  "organizationDefaultNotice": "Tu espacio principal se inicializará automáticamente.",
  "google": "Google",
  "facebook": "Facebook",
  "instagram": "Instagram",
  "whatsapp": "WhatsApp",
  "sms": "SMS",
  "providerUnavailableTooltip": "El inicio de sesión con {{provider}} aún no está configurado",
  "enterPhone": "Por favor introduce un número de teléfono válido",
  "enterValidCode": "Por favor introduce el código de 6 dígitos",
  "otpSendFailed": "Error al enviar el código de verificación",
  "otpVerifyFailed": "Código de verificación inválido",
  "otpPhoneDescription": "Enviaremos un código de seguridad de 6 dígitos a tu teléfono.",
  "otpCodeDescription": "Introduce el código de 6 dígitos enviado a {{phone}}.",
  "phoneFormatHint": "Incluye el código de país (ej. +56 para Chile, +1 para EE.UU.).",
  "sendVerificationCode": "Enviar Código de Verificación",
  "changePhoneNumber": "Cambiar teléfono",
  "resendCode": "Reenviar código",
  "resendInCountdown": "Reenviar en {{count}}s",
  "cancelToSignIn": "Volver a iniciar sesión",
  "useDifferentEmail": "Usar un correo diferente",
  "missingMagicToken": "Falta el token del enlace mágico",
  "magicLinkVerifyFailed": "No se pudo verificar el enlace mágico",
  "magicLinkRequestFailed": "Error al solicitar el enlace mágico",
  "completingSocialLogin": "Completando tu inicio de sesión...",
  "socialCallbackErrorTitle": "No se pudo completar el inicio de sesión social",
  "socialCallbackDenied": "La autorización fue cancelada o rechazada.",
  "unsupportedSocialProvider": "Proveedor de autenticación social no compatible.",
  "missingSocialCode": "Falta el código de autorización del proveedor social.",
  "invalidOAuthState": "Error de validación de seguridad durante el inicio de sesión. Intenta nuevamente.",
  "socialProviderNotConfigured": "Este proveedor de inicio de sesión social no está configurado en este entorno.",
  "dataDeletionStatusTitle": "Eliminación de datos sociales completada",
  "dataDeletionStatusDescription": "Tu identidad de inicio de sesión social de Meta (Facebook / Instagram) y los datos vinculados han sido eliminados de HomyOS.",
  "dataDeletionCodeLabel": "Código de confirmación",
  "social": {
    "continueWithApple": "Continuar con Apple",
    "signInWithApple": "Iniciar sesión con Apple",
    "continueWithGoogle": "Continuar con Google",
    "continueWithFacebook": "Continuar con Facebook",
    "continueWithInstagram": "Continuar con Instagram",
    "continueWithWhatsApp": "Continuar con WhatsApp",
    "continueWithSms": "Iniciar sesión con SMS",
    "lastUsed": "Último usado",
    "orContinueWith": "O continuar con",
    "providerDisabled": "Este método de inicio de sesión no está disponible actualmente.",
    "placeholderToast": "El inicio de sesión con {{provider}} estará disponible en la próxima versión. En móviles, usa Apple o Contraseña."
  },
  "hero": {
    "badge": "HomyOS 2.0",
    "title": "El sistema operativo para flujos de propiedades.",
    "subtitle": "Gestiona propiedades, evalúa arrendatarios, firma contratos y cobra arriendoes desde una plataforma unificada y elegante.",
    "pill1": "99.8% Cobro de Arriendo Puntual",
    "pill1Sub": "Conciliación automatizada",
    "pill2": "Despacho Automático de Mantenimiento",
    "pill2Sub": "Aprobación con HITL para contratistas",
    "pill3": "Evaluación de Arriendoes con IA",
    "copyright": "© 2026 HomyOS",
    "privacy": "Privacidad",
    "terms": "Términos"
  },
  "qa": {
    "title": "Acceso Rápido de Desarrollo",
    "badge": "DEV QA",
    "description": "Cambia entre personas preconfiguradas para probar permisos, vistas y flujos.",
    "groups": {
      "platform": "Plataforma y Operaciones",
      "residents": "Residentes y Propietarios",
      "contractors": "Contratistas y Terreno",
      "special": "Multi-Rol Adaptativo"
    },
    "instantLogin": "Login en 1 Clic",
    "fillForm": "Rellenar Credenciales",
    "close": "Cerrar"
  },
  "passkey": {
    "passkey": "Passkey",
    "signInWithPasskey": "Iniciar sesión con Clave de Paso (Passkey)",
    "registerTitle": "Configurar una Clave de Paso",
    "registerDescription": "Inicia sesión de forma segura usando Touch ID, Face ID o el bloqueo de pantalla de tu dispositivo sin escribir una contraseña.",
    "registerButton": "Agregar Clave de Paso",
    "prompt": "Usa Touch ID, Face ID o Llave de Seguridad",
    "notSupported": "Las claves de paso no son compatibles con este dispositivo o navegador.",
    "createdSuccess": "¡Clave de paso creada con éxito!",
    "authSuccess": "¡Clave de paso verificada con éxito!",
    "failed": "La autenticación con clave de paso falló. Intenta de nuevo o usa tu contraseña."
  },
  "mfa": {
    "challengeTitle": "Autenticación de Dos Factores",
    "challengeDescription": "Introduce el código de seguridad de 6 dígitos generado por tu aplicación de autenticación.",
    "subtitleSms": "Introduce el código de verificación de 6 dígitos enviado a tu teléfono.",
    "codeLabel": "Código de Seguridad de 6 Dígitos",
    "codePlaceholder": "000000",
    "verifyButton": "Verificar e Iniciar Sesión",
    "verifying": "Verificando...",
    "useBackupCode": "Usar un código de respaldo",
    "useTotp": "Usar código de la aplicación de autenticación",
    "backupCodeLabel": "Código de Respaldo",
    "backupCodeDescription": "Introduce un código de respaldo de un solo uso de 8 caracteres.",
    "backupCodePlaceholder": "Introduce código de respaldo (ej. ABCD-1234)",
    "invalidCode": "Código de seguridad inválido. Revisa tu aplicación e inténtalo de nuevo.",
    "invalidBackupCode": "Código de respaldo inválido o ya utilizado."
  },
  "slides": {
    "property": {
      "title": "Gestión Centralizada de Propiedades.",
      "subtitle": "Administra unidades, controla finanzas y visualiza analíticas en una plataforma unificada y hermosa.",
      "pill1Title": "99.8% Cobro a Tiempo",
      "pill1Sub": "Conciliación automatizada de UF",
      "pill2Title": "Copiloto Inmobiliario con IA",
      "pill2Sub": "Insights proactivos de portafolio"
    },
    "maintenance": {
      "title": "Mantenimiento Automatizado.",
      "subtitle": "Conecta sin problemas con contratistas verificados como Patricio para mantener tus propiedades en perfecto estado.",
      "pill1Title": "Despacho de Mantenimiento",
      "pill1Sub": "Aprobación de contratista HITL",
      "pill2Title": "Cotización Inteligente",
      "pill2Sub": "Costos de reparación verificados por IA"
    },
    "tenant": {
      "title": "Mejor Experiencia para Arrendatarios.",
      "subtitle": "Onboarding simplificado, contratos 100% digitales y pagos sin fricción para arrendatarios modernos.",
      "pill1Title": "Arriendoes Más Rápidos",
      "pill1Sub": "Contratos 100% Digitales",
      "pill2Title": "Pagos Sin Fricción",
      "pill2Sub": "Cobros recurrentes automáticos"
    }
  },
  "oauth": {
    "title": "Autorizar {{clientName}}",
    "subtitle": "desea conectarse a tu espacio de trabajo de Homy",
    "clientUnknown": "Aplicación Externa",
    "signInTitle": "Inicia sesión para conectar con {{clientName}}",
    "signInSubtitle": "Crea una cuenta o inicia sesión para autorizar el acceso a tu espacio de trabajo de Homy.",
    "permissionsRequested": "Permisos solicitados",
    "workspaceLabel": "Seleccionar Espacio de Trabajo / Organización",
    "workspaceDescription": "Elige la organización a la que esta aplicación tendrá acceso.",
    "workspacePlaceholder": "Selecciona una organización...",
    "noWorkspaces": "No hay organizaciones disponibles",
    "currentAccount": "Sesión iniciada como",
    "switchAccount": "Iniciar sesión con otra cuenta",
    "starterOrgNotice": "Se aprovisionará automáticamente una organización inicial para tu cuenta.",
    "termsNotice": "Al hacer clic en Autorizar, permites que {{clientName}} acceda a tu información de acuerdo con sus términos y política de privacidad.",
    "authorizeButton": "Autorizar",
    "cancelButton": "Cancelar",
    "authorizing": "Autorizando...",
    "canceling": "Cancelando...",
    "scopes": {
      "openid": "Verificar tu identidad (OpenID Connect)",
      "profile": "Acceder a tu información básica de perfil (nombre, avatar)",
      "email": "Ver tu dirección de correo electrónico",
      "offline_access": "Mantener acceso sin conexión mediante tokens de actualización",
      "homy:all": "Acceso total a todos los datos y operaciones del espacio de trabajo",
      "homy:mcp": "Ejecutar herramientas de agentes de IA y acciones de Model Context Protocol (MCP)",
      "mcp:read": "Acceso de lectura a propiedades, tareas, arrendatarios y mantenimiento vía MCP",
      "mcp:write": "Crear y modificar tareas, órdenes de mantenimiento y propiedades vía MCP",
      "read": "Acceso de lectura a los datos de tu cuenta",
      "write": "Acceso de escritura para realizar acciones en tu nombre"
    },
    "errors": {
      "missingParams": "Solicitud de autorización inválida: faltan parámetros requeridos (client_id, redirect_uri o code_challenge).",
      "clientFetchFailed": "No se pudieron verificar los detalles del cliente. Puedes continuar si confías en esta aplicación.",
      "authorizeFailed": "No se pudo completar la autorización. Por favor intenta de nuevo.",
      "accessDenied": "La solicitud de autorización fue cancelada."
    }
  }
}
